<div class="fab-icon-holder" [ngClass]="{ 'engaged-button': currentSliderVolumeLevel === 0 }">
  <button
    class="material-icons"
    (click)="parentClickedToggleMusic()"
    data-testid="btn-toggle-music"
    [matTooltip]="getTooltipText"
  >
    <mat-icon aria-hidden="false" aria-label="Music Volume Control">{{ currentIcon }}</mat-icon>
  </button>
</div>
